export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const ACCOUNT_ACTIVATION = 'REGISTER_SUCCESS';
export const CARD_EXPIRY_DETAILS = 'CARD_EXPIRY_DETAILS';
export const USER_INFO_DETAILS = 'USER_INFO_DETAILS';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const UPDATE_DATA = 'UPDATE_DATA';
export const UPDATE_LOCATIONS_DATA = 'UPDATE_LOCATIONS_DATA';

export const SHOW_APP_LOADER = 'SHOW_APP_LOADER';
export const HIDE_APP_LOADER = 'HIDE_APP_LOADER';

export const TOGGLE_GUEST_UPGRADE_MODAL = "TOGGLE_GUEST_UPGRADE_MODAL"

export const POST_LOAD_URL = 'POST_LOAD_URL';
export const POST_INVENTORY_URL = 'POST_INVENTORY_URL';
export const CREATED_NEEDS = 'CREATED_NEEDS';
export const CREATED_INVENTORY = 'CREATED_INVENTORY';
export const BIDS_INVENTORY = 'BIDS_INVENTORY';
export const REQUESTED_ID = 'REQUESTED_ID';

export const BID_NEEDS = 'BID_NEEDS';
export const PT_PLUS_PAGE = 'PT_PLUS_PAGE';
export const SEARCH_POST = 'SEARCH_POST';
export const SEARCH_INVENTORY = 'SEARCH_INVENTORY';
export const ORDERS = 'ORDERS';
export const MYCOMMUNITY = 'MYCOMMUNITY';
export const FAQ = 'FAQ';
export const MANAGE_ACCOUNT = 'MANAGE_ACCOUNT';
export const NOTIFICATION = 'NOTIFICATION';
export const DETAILS = 'DETAILS';
export const CHECKOUT = 'CHECKOUT';
export const RESOLUTION_CENTER = 'RESOLUTION_CENTER';
export const LOCAL_STORE_DATA = 'LOCAL_STORE_DATA';
export const BIDS_PAGINATION = 'BIDS_PAGINATION';
export const NEARBY_PAGINATION = 'NEARBY_PAGINATION';
export const MYORDER_PAGINATION = 'MYORDER_PAGINATION';